import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { OfflineBanner } from "../components/OfflineBanner";

/** Shown offline for pages that need the API (library, settings, invites). */
export function OfflineUnavailablePage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-page">
      <OfflineBanner />
      <main className="flex flex-1 items-center justify-center px-4">
        <div className="flex max-w-sm flex-col items-center gap-3 text-center">
          <span
            className="material-symbols-outlined text-4xl text-tertiary"
            aria-hidden="true"
          >
            cloud_off
          </span>
          <h1 className="text-lg font-bold text-primary">
            Not available offline
          </h1>
          <p className="text-sm text-secondary">
            This page needs a connection. Your saved trips are still available.
          </p>
          <Button
            variant="primary"
            icon="luggage"
            onClick={() => navigate("/")}
          >
            Go to trips
          </Button>
        </div>
      </main>
    </div>
  );
}
